var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 17",
    fill: "#ACB0B3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_3953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3354 17H2.68125C1.68367 17 0.875 16.1913 0.875 15.1937V1.80625C0.875 0.808673 1.68367 0 2.68125 0H18.3354C19.333 0 20.1417 0.808673 20.1417 1.80625V15.1937C20.1417 16.1913 19.333 17 18.3354 17ZM5.08958 2.10729C3.92576 2.10729 2.98229 3.05076 2.98229 4.21458C2.98229 5.37841 3.92576 6.32187 5.08958 6.32187C6.25341 6.32187 7.19688 5.37841 7.19688 4.21458C7.19688 3.05076 6.25341 2.10729 5.08958 2.10729ZM3.28333 14.7333H17.7333V7.82708L14.4401 4.53388C14.2638 4.35754 13.9779 4.35754 13.8015 4.53388L8.70208 9.63333L6.61304 7.54429C6.43671 7.36796 6.15079 7.36796 5.97442 7.54429L3.28333 10.2354V14.7333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_3953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2667,
    height: 17,
    fill: "white",
    transform: "translate(0.875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.792553b715e6d874a3366074b575e71b.svg";
export { ForwardRef as ReactComponent };